import { render, staticRenderFns } from "./VersionDetail.vue?vue&type=template&id=66d74380&scoped=true&"
import script from "./VersionDetail.vue?vue&type=script&lang=js&"
export * from "./VersionDetail.vue?vue&type=script&lang=js&"
import style0 from "./VersionDetail.vue?vue&type=style&index=0&id=66d74380&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d74380",
  null
  
)

export default component.exports